var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4963 18.5221C14.3151 18.5221 14.1338 18.4554 13.9907 18.3123C13.714 18.0356 13.714 17.5777 13.9907 17.301L19.2759 12.0159L13.9907 6.7307C13.714 6.45404 13.714 5.99612 13.9907 5.71946C14.2674 5.4428 14.7253 5.4428 15.0019 5.71946L20.7927 11.5102C21.0694 11.7869 21.0694 12.2448 20.7927 12.5215L15.0019 18.3123C14.8588 18.4554 14.6776 18.5221 14.4963 18.5221Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1268 12.7313H4.07097C3.67983 12.7313 3.35547 12.4069 3.35547 12.0158C3.35547 11.6247 3.67983 11.3003 4.07097 11.3003H20.1268C20.5179 11.3003 20.8423 11.6247 20.8423 12.0158C20.8423 12.4069 20.5179 12.7313 20.1268 12.7313Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon_arrow_right.2e2f70935d4040352ab0ca045b8b44a2.svg";
export { ForwardRef as ReactComponent };